<template>
  <vx-card no-shadow>
    <h2 class="mb-6">User - Skills</h2>

    <vs-table v-if="user" ref="table" class="mt-8" v-model="selected" :data="skills" @selected="onSkillClicked(selected)">
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center data-list-btn-container">
          <!-- ADD NEW $AuthService.hasPermission('life.admin.users.create') -->
          <div
            v-if="hasPermission('life.admin.user.skills.edit')"
            @click="onAddSkill"
            class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Add Skill</span>
          </div>
        </div>
      </div>

      <template slot="thead">
        <vs-th sort-key="key">Name</vs-th>
        <vs-th sort-key="sourceId">Source</vs-th>
        <vs-th sort-key="date">Date added</vs-th>
        <vs-th>Action</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.key }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.sourceId }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">
                {{ moment(tr.date).format("YYYY-MM-DD HH:mm:ss") }}
              </p>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <feather-icon
                v-if="hasPermission('life.admin.user.skills.edit')"
                icon="TrashIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-2"
                @click.stop="confirmDelete(tr)"
              />
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <vs-popup title="Add Skill" :active.sync="addSkillPopupActive">
      <div>
        <p>Select Type:</p>
        <vs-select class="mt-2 w-full" v-model="selectedType">
          <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item, index) in skillTypes" />
        </vs-select>

        <vs-button
          v-if="hasPermission('life.admin.user.skills.edit')"
          @click="addSkillToUser"
          class="mt-10"
          color="primary"
          type="filled"
          icon-pack="feather"
          icon="done"
        >
          Add Skill
        </vs-button>
      </div>
    </vs-popup>
  </vx-card>
</template>

<script>
import moment from "moment";

export default {
  computed: {
    skills() {
      return this.user.assessment.assessmentItems.map(e => {
        switch (e.key) {
          case "bartender":
            e.key = "bartender-performance";
            break;
          case "runner":
            e.key = "runner-performance";
            break;
          case "host":
            e.key = "host-performance";
            break;
          case "wardrobe/cover":
            e.key = "wardrobe/cover-performance";
            break;
          case "shiftmanager":
            e.key = "shiftmanager-performance";
            break;
          case "waiter":
            e.key = "waiter-performance";
            break;
        }
        return e;
      });
    }
  },
  data() {
    return {
      moment,
      user: null,
      selected: null,

      addSkillPopupActive: false,

      selectedType: "staffmeeting",
      skillTypes: [
        { text: "Playbook", value: "playbook" },
        { text: "WinWin", value: "winwin" },
        { text: "Ambassador", value: "ambassador" },
        { text: "Walk Your Talk", value: "walkyourtalk" },
        { text: "Staff meetings", value: "staffmeeting" },
        { text: "Shifts", value: "shifts" },
        // { text: "Camp", value: "camp" },

        // { text: "Performance", value: "performance" },
        { text: "Performance: Bartender", value: "bartender" },
        { text: "Performance: Runner", value: "runner" },
        { text: "Performance: Wardrobe/Cover", value: "wardrobe/cover" },
        { text: "Performance: Host", value: "host" },
        { text: "Performance: Shiftmanager", value: "shiftmanager" },
        { text: "Performance: Waiter", value: "waiter" },

        { text: "VMT: Basic", value: "vmtbasic" },
        { value: "rookie", text: "VMT Rookie" },
        { text: "VMT: Skilled", value: "skilled" },
        { text: "VMT: Expert", value: "expert" },
        { text: "VMT: Paratus", value: "paratus" },
        { text: "VMT: VM Exam", value: "vmexam" },
        { text: "VMT: Webinar 1", value: "vmtwebinar1" },
        { text: "VMT: Webinar 2", value: "vmtwebinar2" },
        { text: "VMT: Webinar 3", value: "vmtwebinar3" },
        { text: "VMT: Webinar 4", value: "vmtwebinar4" },
        { text: "VMT: Webinar 5", value: "vmtwebinar5" },
        { text: "VMT: Webinar 6", value: "vmtwebinar6" },
        { text: "VMT: Webinar 7", value: "vmtwebinar7" },
        { text: "VMT: Webinar 8", value: "vmtwebinar8" },
        { text: "VMT: Webinar 9", value: "vmtwebinar9" },
        { text: "VMT: Webinar 10", value: "vmtwebinar10" },
        { text: "VMT: Webinar Exam", value: "vmtwebinarexam" },

        { text: "SoMe", value: "some" },
        { text: "SoMe 1", value: "some1" },
        { text: "SoMe 2", value: "some2" },

        { text: "Handbook", value: "handbook" },
        { text: "Masterclass", value: "masterclass" },
        { text: "Canva Basic", value: "canvabasic" },

        { value: "firstaid", text: "First Aid" },
        { value: "evacuation", text: "Evacuation" },
        { value: "tvm", text: "TVM" },
        { value: "tvmtime", text: "TVM Time Management" },
        { value: "tvmcoach", text: "TVM Coaching" },
        { value: "tvmmotiv", text: "TVM Motivation" },
        { value: "tvmhpt", text: "TVM High Performance Team" },
        { value: "tvmrecruit", text: "TVM Recruitment" },
        { value: "tvmonboard", text: "TVM Onboarding" },
        { value: "tvmstars", text: "TVM Stars" },
        { value: "tvmpresentation", text: "TVM Presenation Technique" },
        { value: "channel_basic", text: "Channel Basic" },
        { value: "channel_advanced", text: "Channel Advanced" },
        { value: "channel_pro", text: "Channel Pro" },

        { value: "mandatory_age_verification", text: "Mandatory age verification" },
        { value: "mandatory_fire_induction", text: "Mandatory fire induction" },
        { value: "mandatory_fire_awareness", text: "Mandatory fire awareness" },
        { value: "mandatory_allergens_in_work", text: "Mandatory allergens in work" },
        { value: "mandatory_alcohol_licensing", text: "Mandatory alcohol licensing" },
        { value: "mandatory_health_and_safety", text: "Mandatory health and safety" },
        { value: "mandatory_manual_handling", text: "Mandatory manual handling" },
        { value: "mandatory_vulnerability_and_wellbeing", text: "Mandatory vulnerability and wellbeing" },
        { value: "mandatory_pci-dss", text: "Mandatory pci-dss" },
        { value: "mandatory_equality_and_diversity", text: "Mandatory equality and diversity" },
        { value: "mandatory_acting_fire_warden", text: "Mandatory acting fire warden" },
        { value: "mandatory_phishing", text: "Mandatory phishing" },

        { text: "Social", value: "social" },
      ]
    };
  },
  methods: {
    onAddSkill: function () {
      this.addSkillPopupActive = true;
    },

    addSkillToUser: function () {
      this.$vs.loading();

      const payload = {
        skillType: this.selectedType
      };

      this.$http
        .post(process.env.VUE_APP_API + "/user/" + this.user.userId + "/info/skills", payload)
        .then((/*resp*/) => {
          this.addSkillPopupActive = false;

          this.getUser(this.user.userId);
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.$vs.loading.close();
        });

      // If we just added a performance course, also add the performance value
      if (
        this.selectedType === "bartender" ||
        this.selectedType === "runner" ||
        this.selectedType === "wardrobe/cover" ||
        this.selectedType === "host" ||
        this.selectedType === "shiftmanager" ||
        this.selectedType === "waiter"
      ) {
        this.selectedType = "performance";
        this.addSkillToUser();
      }
    },

    getUser: function (userId) {
      this.$vs.loading();

      this.$http
        .get(process.env.VUE_APP_API + "/users/" + userId)
        .then(resp => {
          this.user = resp.data;

          console.log(this.user);
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    onSkillClicked() {},

    confirmDelete(skill) {
      if (!this.hasPermission("life.admin.user.skills.edit")) return;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: `Are you sure you want to delete the skill ${skill.key}?`,
        accept: () => this.deleteSkill(skill.key, skill.sourceId)
      });
    },

    deleteSkill(key, sourceId) {
      this.$vs.loading();

      this.$http
        .delete(process.env.VUE_APP_API + "/user/" + this.user.userId + "/info/skills/" + sourceId)
        .then((/*resp*/) => {
          console.log("Skill deleted");
          this.getUser(this.$route.params.userId);
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    }
  },
  created() {
    this.getUser(this.$route.params.userId);
  }
};
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>